<div class="d-flex">
  <div class="row setting-card-container mx-auto">
    <mat-card class="mat-elevation-z4 w-100">
      <mat-card-title>Superuser</mat-card-title>
      <mat-card-content>
        <mat-tab-group>
          <mat-tab label="Aktenzeichen Übersicht">
            <div class="container-fluid p-3">
              <div class="row w-100 m-0">
                <div class="col-sm-12 p-0">
                  <h2>Nächste Aktenzeichen pro Dienstnehmer</h2>
                  <small>Zeigt an, welches Aktenzeichen als nächstes vergeben wird (Anzeige und BOM). Mit "Set" können Sie den Wert manuell überschreiben.</small>

                  <div *ngIf="loadingOverview" class="mt-4">
                    <p>Laden...</p>
                  </div>

                  <table *ngIf="!loadingOverview && aktenzeichenOverview.length > 0" class="table table-striped table-sm mt-4">
                    <thead>
                      <tr>
                        <th class="bold">Dienstnehmer</th>
                        <th class="bold">Dienst-Nr</th>
                        <th class="bold">Letztes AKZ (DB)</th>
                        <th class="bold">Nächste Anzeige AKZ</th>
                        <th class="bold">Nächste BOM AKZ</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let row of aktenzeichenOverview">
                        <td>{{ row.name }}</td>
                        <td>{{ row.dienstnr_id }}</td>
                        <td>{{ row.last_db_aktenzeichen ?? '–' }}</td>
                        <td>
                          <button
                            type="button"
                            class="mr-2 bg-white hover:bg-gray-100 text-gray-400 text-xs py-1 px-2 rounded border border-gray-300"
                            (click)="openSetDialog(row, 0)">
                            Set
                          </button>
                          {{ row.next_anzeige }}
                        </td>
                        <td>
                          <button
                            type="button"
                            class="mr-2 bg-white hover:bg-gray-100 text-gray-400 text-xs py-1 px-2 rounded border border-gray-300"
                            (click)="openSetDialog(row, 1)">
                            Set
                          </button>
                          {{ row.next_bom }}
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  <div *ngIf="!loadingOverview && aktenzeichenOverview.length === 0" class="mt-4">
                    <p>Keine Daten vorhanden.</p>
                  </div>

                  <button mat-raised-button color="primary" class="mt-2" (click)="loadAktenzeichenOverview()">
                    Aktualisieren
                  </button>
                </div>
              </div>
            </div>
          </mat-tab>

          <mat-tab label="DB Einstellungen">
            <div class="container-fluid p-3">
              <div class="row w-100 m-0">
                <div class="col-sm-12 col-md-4 p-0">
                  <h2>DB Einstellungen (JSON)</h2>
                  <small>Hier können Sie alle Einstellungen direkt als JSON bearbeiten. Alle Schlüssel/Werte aus der Datenbank werden angezeigt.</small>
                  <div class="mt-2" style="font-size: 11px; color: #6b7280;">
                    <strong>Hinweis:</strong> Änderungen werden direkt in die Datenbank geschrieben. Bitte achten Sie auf gültiges JSON-Format.
                  </div>
                </div>
                <div class="col-sm-12 col-md-7 offset-md-1 p-1">
                  <div class="mt-3">
                    <div *ngIf="rawSettingsLoading" class="mb-2">
                      <p>Laden...</p>
                    </div>

                    <div *ngIf="!rawSettingsLoading">
                      <textarea
                        [(ngModel)]="rawSettingsJson"
                        style="width: 100%; min-height: 450px; font-family: 'Consolas', 'Monaco', 'Courier New', monospace; font-size: 12px; line-height: 1.5; padding: 12px; border: 1px solid #d1d5db; border-radius: 6px; background-color: #f9fafb; color: #1f2937; resize: vertical; tab-size: 2;"
                        spellcheck="false"
                        placeholder="{ ... }"></textarea>

                      <div *ngIf="rawSettingsError" style="margin-top: 6px; padding: 8px 12px; background: #fef2f2; border: 1px solid #fca5a5; border-radius: 4px; color: #dc2626; font-size: 12px;">
                        {{ rawSettingsError }}
                      </div>

                      <div style="display: flex; gap: 8px; margin-top: 10px;">
                        <button mat-raised-button color="primary" (click)="saveRawSettings()" [disabled]="rawSettingsSaving">
                          {{ rawSettingsSaving ? 'Speichern...' : 'Speichern' }}
                        </button>
                        <button mat-raised-button (click)="loadRawSettings()" [disabled]="rawSettingsLoading" style="background-color: #6b7280; color: #fff;">
                          Neu laden
                        </button>
                        <button mat-raised-button (click)="formatRawJson()" style="background-color: #e5e7eb; color: #374151;">
                          JSON formatieren
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </mat-tab>

          <mat-tab label="Demo-Mode">
            <div class="container-fluid p-3">
              <div class="row w-100 m-0">
                <div class="col-sm-12 p-0">
                  <h2>Demo-Mode</h2>
                  <small>Globaler Schalter in den DB-Einstellungen (JSON-Feld <code>DEMO_MODE</code>).</small>

                  <div
                    class="demo-mode-box mt-3"
                    style="padding: 14px 16px; border: 1px solid #e5e7eb; border-radius: 8px; background: #f9fafb; max-width: 560px;">
                    <div style="display: flex; align-items: flex-start; justify-content: space-between; gap: 16px;">
                      <div>
                        <div style="font-size: 13px; font-weight: 600; color: #111827;">Demo-Mode</div>
                        <small class="text-gray-500" style="display: block; margin-top: 6px; font-size: 11px; line-height: 1.45;">
                          Wenn aktiviert: „Zu Mandate übertragen“, „Auf Überfällig setzen“ und Bearbeitungsansichten sind für alle Benutzer gesperrt.
                        </small>
                      </div>
                      <mat-slide-toggle
                        color="primary"
                        [checked]="demoMode"
                        [disabled]="savingDemoMode"
                        (change)="toggleDemoMode($event.checked)">
                      </mat-slide-toggle>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </mat-tab>

          <mat-tab label="Rollen & Rechte">
            <div class="container-fluid p-3">
              <div class="row w-100 m-0">
                <div class="col-sm-12 p-0">
                  <h2>Rollen &amp; Rechte</h2>
                  <small>Legen Sie fest, welche Rolle welche Module sehen darf. Superuser hat immer vollen Zugriff.</small>

                  <div *ngIf="loadingRolePerms" class="mt-4">
                    <p><em>Aktualisiere vom Server...</em></p>
                  </div>

                  <div *ngIf="rolePermError" class="mt-3" style="padding: 8px 12px; background: #fffbeb; border: 1px solid #fcd34d; border-radius: 4px; color: #92400e; font-size: 12px;">
                    {{ rolePermError }}
                  </div>

                  <div *ngIf="!rolePermData && !loadingRolePerms" class="mt-4">
                    <p>Keine Daten geladen.</p>
                    <button mat-raised-button color="primary" class="mt-2" (click)="loadRolePermissions()">Erneut laden</button>
                  </div>

                  <div *ngIf="rolePermData" class="mt-4" style="overflow-x: auto;">
                    <table class="table table-striped table-sm" style="font-size: 12px; min-width: 700px;">
                      <thead>
                        <tr>
                          <th class="bold">Rolle</th>
                          <th *ngFor="let mod of rolePermData.modules" class="bold" style="text-align: center;">{{ mod.label }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let role of rolePermData.roles">
                          <td class="bold">{{ role.name }}</td>
                          <td *ngFor="let mod of rolePermData.modules" style="text-align: center;">
                            <input
                              type="checkbox"
                              [checked]="isRolePermAllowed(role.id, mod.id)"
                              [disabled]="role.id === ROLE_SUPERUSER"
                              (change)="setRolePermAllowed(role.id, mod.id, $any($event.target).checked)" />
                          </td>
                        </tr>
                      </tbody>
                    </table>

                    <button mat-raised-button color="primary" class="mt-2" (click)="saveRolePermissions()" [disabled]="savingRolePerms">
                      {{ savingRolePerms ? 'Speichern...' : 'Speichern' }}
                    </button>
                    <button mat-raised-button class="mt-2 ml-2" (click)="loadRolePermissions()" [disabled]="loadingRolePerms" style="background-color: #6b7280; color: #fff;">
                      Neu laden
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </mat-tab>
        </mat-tab-group>
      </mat-card-content>
    </mat-card>
  </div>
</div>

<div *ngIf="showRawSettingsConfirm" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center" style="z-index: 9999;">
  <div class="bg-white rounded-lg p-6 shadow-xl" style="width: 440px;">
    <h3 class="text-lg font-bold mb-3" style="color: #dc2626;">Warnung</h3>
    <p class="text-sm text-gray-700" style="line-height: 1.6;">
      Sind Sie sicher? Wenn Sie etwas Falsches eingegeben haben, kann es dazu führen, dass die Software nicht mehr funktioniert.
      Bitte bestätigen Sie diese Aktion.
    </p>
    <div class="flex justify-end space-x-2 mt-4">
      <button type="button" class="bg-gray-300 hover:bg-gray-400 text-gray-800 py-2 px-4 rounded" (click)="showRawSettingsConfirm = false">
        Nein
      </button>
      <button type="button" class="bg-red-500 hover:bg-red-700 text-white py-2 px-4 rounded" (click)="confirmSaveRawSettings()">
        Ja, speichern
      </button>
    </div>
  </div>
</div>

<div *ngIf="showSetDialog" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center" style="z-index: 9999;">
  <div class="bg-white rounded-lg p-6 shadow-xl" style="width: 420px;">
    <h3 class="text-lg font-bold mb-3">Aktenzeichen setzen</h3>

    <p class="text-sm text-gray-600 mb-1">
      Dienstnehmer: <strong>{{ setDialogData.name }}</strong> ({{ setDialogData.dienstnr_id }})
    </p>
    <p class="text-sm text-gray-600 mb-1">
      Modus: <strong>{{ setDialogData.bomLabel }}</strong>
    </p>
    <p class="text-sm text-gray-600 mb-3">
      Aktueller nächster Wert: <strong>{{ setDialogData.currentValue }}</strong>
    </p>

    <label class="block text-sm font-medium mb-1">Neues Aktenzeichen:</label>
    <input
      type="text"
      [(ngModel)]="newAktenzeichenValue"
      class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 mb-2"
      placeholder="z.B. 926100000" />

    <p *ngIf="newAktenzeichenValue && !isNaN(+newAktenzeichenValue)" class="text-xs text-gray-500 mb-4">
      Ein Dummy-Eintrag mit diesem Wert wird erstellt (Status: Ungültig).
      <br />
      Nächstes automatisch vergebenes Aktenzeichen wird dann: <strong>{{ +newAktenzeichenValue + 1 }}</strong>
    </p>

    <div class="flex justify-end space-x-2 mt-4">
      <button type="button" class="bg-gray-300 hover:bg-gray-400 text-gray-800 py-2 px-4 rounded" (click)="closeSetDialog()" [disabled]="savingAktenzeichen">
        Abbrechen
      </button>
      <button type="button" class="bg-blue-500 hover:bg-blue-700 text-white py-2 px-4 rounded" (click)="confirmSetAktenzeichen()" [disabled]="savingAktenzeichen">
        {{ savingAktenzeichen ? 'Speichern...' : 'Speichern' }}
      </button>
    </div>
  </div>
</div>
